export default "__VITE_ASSET__DswvrRPf__"